import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const SendIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Send",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m26.57 2.26-22 13.48c-.95.59-.89 1.42.13 1.89l5.22 2.24L22.23 8.34c1.63-1.52 1.89-1.31.5.45L11.26 23.21V29c0 1.11.59 1.33 1.32.49l5.31-6.18 5.99 2.57c.19.11.42.17.66.17.76 0 1.39-.62 1.39-1.38S28.09 3.2 28.09 3.2c.11-1.1-.58-1.53-1.53-.95Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M20.24 29.1c-1.02 0-2-.4-2.75-1.15l-5.12-5.12c-.65-.65-1-1.51-1-2.43s.36-1.78 1.01-2.42l6.46-6.46a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L14 19.6c-.22.22-.34.5-.34.81s.12.59.33.81l5.13 5.13c.41.42 1 .57 1.57.42s1-.58 1.15-1.15L26.77 7.2c.15-.57 0-1.15-.42-1.57s-1-.57-1.57-.42L6.35 10.14c-.57.15-1 .58-1.15 1.15s0 1.15.42 1.57l3.67 3.67c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0L4 14.48c-1-1-1.38-2.41-1.01-3.78s1.4-2.4 2.77-2.77l18.42-4.94c1.37-.37 2.78.01 3.78 1.01s1.38 2.41 1.01 3.78L24.04 26.2c-.37 1.37-1.4 2.4-2.77 2.77-.34.09-.69.14-1.03.14Z"
      })
    })
  }));
};
SendIcon.displayName = 'SendIcon';